import { PropositionDisplayPayload } from '@/models/adobe-target';
import { PropositionDisplayEvent } from '@/services/analytics/events';
import { AnalyticsEventType } from '../models';

export class AdobeTargetPropositionDisplayEvent {
  event = AnalyticsEventType.PropositionDisplay;
  decisioning?: PropositionDisplayPayload;
  
  constructor(event: PropositionDisplayEvent) {
    this.decisioning = { 
      propositions: event.targetResponsePayloads.map(payload => ({
        id: payload?.id ?? '',
        scope: payload.scope ?? '',
        scopeDetails: payload.scopeDetails ?? {}, 
      }))
    }
  }
}